import { createTheme } from '@material-ui/core/styles';
import { colors } from './colors';
import { typography } from './typography';
import variables from '../Sys/variable.scss';

export const muiTheme = createTheme({
  palette: {
    ...colors
  },
  typography: {
    ...typography
  },

  // Component style overrides (color-only)
  overrides: {
    MuiButton: {
      outlined: {
        borderColor: colors.grey[200],
        color: colors.common.black
      },
      outlinedPrimary: {
        background: variables.primaryColor,
        color: colors.common.white,
        '&:hover': {
          backgroundColor: variables.buttonHoverColor,
          color: colors.common.white
        }
      },
      outlinedSecondary: {
        backgroundColor: colors.secondary.main,
        color: colors.common.white,
        '&:hover': {
          backgroundColor: colors.secondary.light,
          color: colors.common.white
        }
      }
    },
    MuiIconButton: {
      colorPrimary: {
        background: colors.primary.main,
        color: colors.common.white,
        '&:hover': {
          backgroundColor: colors.common.black,
          color: colors.common.white
        },
        // Radio and Checkbox are IconButtons. This fill is for toolbar icons only.
        '&.MuiRadio-root, &.MuiCheckbox-root': {
          background: 'transparent',
          color: colors.primary.main,
          '&:hover': {
            backgroundColor: 'rgba(61, 125, 221, 0.08)',
            color: colors.primary.main
          },
          '&.Mui-checked': {
            color: colors.primary.main,
            background: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(61, 125, 221, 0.08)',
              color: colors.primary.main
            }
          },
          '&.Mui-disabled': {
            color: '#c5ced9',
            background: 'transparent'
          }
        }
      },
      colorSecondary: {
        backgroundColor: colors.common.white,
        color: colors.grey[400],
        '&.MuiRadio-root, &.MuiCheckbox-root': {
          backgroundColor: 'transparent',
          color: colors.grey[500],
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            color: colors.grey[500]
          },
          '&.Mui-checked': {
            color: colors.secondary.main,
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(236, 122, 18, 0.08)',
              color: colors.secondary.main
            }
          },
          '&.Mui-disabled': {
            color: '#c5ced9',
            backgroundColor: 'transparent'
          }
        }
      },
      sizeSmall: {
        color: colors.grey[400],
        '&:hover': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: colors.common.white
        }
      },
      outlined: {
        borderColor: colors.grey[200]
      }
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: variables.primaryColor
        }
      },
      selected: {
        backgroundColor: variables.primaryColor
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: colors.grey[200]
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: colors.grey[200]
      }
    },
    MuiDialogActions: {
      root: {
        borderTopColor: colors.grey[200]
      }
    },
    MuiRadio: {
      root: {
        borderColor: colors.grey[200]
      }
    },
    MuiInput: {
      root: {
        borderColor: '#838383'
      }
    },
    MuiBadge: {
      colorSecondary: {
        color: '#fff'
      }
    },
    MuiTableHead: {
      root: {
        backgroundColor: variables.primaryColor
      }
    }
  }
});

export default muiTheme;
